import Icon from '../../../components/AppIcon';

interface PopularTagsProps {
  tags: Array<{ name: string; count: number; }>;
  onTagClick: (tag: string) => void;
}

const PopularTags = ({ tags, onTagClick }: PopularTagsProps) => {
  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Tag" className="w-5 h-5 text-primary" />
        <h3 className="text-lg font-semibold text-text-primary">Popular Topics</h3>
      </div>

      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <button
            key={tag.name}
            onClick={() => onTagClick(tag.name)}
            className="inline-flex items-center space-x-2 px-4 py-2 bg-surface hover:bg-primary/10 border border-border hover:border-primary/30 rounded-lg text-sm font-medium text-text-primary hover:text-primary transition-all duration-fast"
          >
            <span>{tag.name}</span>
            <span className="text-xs text-text-secondary">({tag.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PopularTags;